import CryptoJS from "crypto-js";

export class DEC {
	static m = "YWVzLTI1Ni1jYmM=";

	constructor(k, v) {
		this.k = CryptoJS.enc.Utf8.parse(k);
		this.v = CryptoJS.enc.Utf8.parse(v);
	}

	decrypt(payload) {
		const dataPayload = CryptoJS.enc.Hex.parse(payload).toString(
			CryptoJS.enc.Base64,
		);

		const decrypted = CryptoJS.AES.decrypt(dataPayload, this.k, {
			iv: this.v,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		});

		const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
		return JSON.parse(decryptedText);
	}

	decrypt2(payload) {
		const dataPayload = CryptoJS.enc.Hex.parse(payload).toString(
			CryptoJS.enc.Base64,
		);

		const decrypted = CryptoJS.AES.decrypt(dataPayload, this.k, {
			iv: this.v,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		});

		const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
		return decryptedText;
	}

	encrypt(payload) {
		const dataPayload = JSON.stringify(payload);
		const encrypted = CryptoJS.AES.encrypt(dataPayload, this.k, {
			iv: this.v,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		});

		return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
	}

	encrypt2(payload) {
		const encrypted = CryptoJS.AES.encrypt(payload, this.k, {
			iv: this.v,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		});
		return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
	}
}

// const AES = require('crypto');
// const CryptoJS = require('crypto-js');

// // @ts-ignore
// window.Buffer = window.Buffer || require('buffer').Buffer;

// export class DEC {
//     static m="YWVzLTI1Ni1jYmM=";

//     constructor(k, v) {
//         this.k = k;
//         this.v = v;
//     }

//     decrypt( payload ) {
//         const cipherBytes = CryptoJS.enc.Base64.parse(payload);
//         const decrypted = CryptoJS.AES.decrypt({ciphertext: cipherBytes}, this.k, {
//             iv: this.v,
//             mode: CryptoJS.mode.CBC,
//             padding: CryptoJS.pad.Pkcs7
//         });
//         return decrypted.toString(CryptoJS.enc.Utf8);
//     }

//     encrypt( payload ) {
//         const cipher = CryptoJS.AES.encrypt(payload, CryptoJS.enc.Utf8.parse(this.k), {
//             iv: CryptoJS.enc.Utf8.parse(this.v),
//             padding: CryptoJS.pad.Pkcs7,
//             mode: CryptoJS.mode.CBC
//         });

//         return cipher.toString();
//     }
// }

/**
export class DEC {
  static m="YWVzLTI1Ni1jYmM=";

  constructor( k, v ) {
    this.k=k;
    this.v =v;
  }

  decrypt( payload) {
    const decipher = AES.createDecipheriv(atob(DEC.m), this.k, this.v);
    const decrypted = decipher.update(payload, "hex", "utf8");
    const data_payload = JSON.parse((decrypted + decipher.final("utf8")));
    return data_payload;
  }

  decrypt2( payload) {
    const decipher = AES.createDecipheriv(atob(DEC.m), this.k, this.v);
    const decrypted = decipher.update(payload, "hex", "utf8");
    return decrypted + decipher.final("utf8");
  }

  encrypt( payload) {
    const data_payload = JSON.stringify(payload);
    const cipher = AES.createCipheriv(atob(DEC.m), this.k, this.v);
    const encrypted = cipher.update(data_payload, "utf8", "hex");
    return ( encrypted + cipher.final("hex") );
  }

  encrypt2( payload) {
    const cipher = AES.createCipheriv(atob(DEC.m), this.k, this.v);
    const encrypted = cipher.update(payload, "utf8", "hex");
    return ( encrypted + cipher.final("hex") );
  }
}
 **/
